import domtoimage from 'dom-to-image'
import moment from 'moment-timezone'
import { useEffect, useState } from 'react'

import { useGetUnitGenericDetails } from '@apps-common/apis/portal/unit/get-unit-generic-details'
import { ButtonRoundLg } from '@apps-common/components/elements'
import { ModalContainer } from '@apps-common/components/modals/modal'
import { QRCodeGenerator } from '@apps-common/components/qr-code/QRCodeGenerator'
import { commonIcons } from '@apps-common/config/icons'
import { ModalDismiss } from '@apps-common/config/modal'

export const QrCodeUnitLabelModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: { unitId: string }
}) => {
  const { unitId } = componentProps
  const [qrData, setQrData] = useState<string>()

  const { data, isLoading, isError } = useGetUnitGenericDetails({ config: { enabled: !!unitId }, unitId })

  useEffect(() => {
    setQrData(`${data?.unitId}|${data?.simId}|${data?.imei}|${data?.serialNo}`)
  }, [data])
  const downloadURI = (uri: string, name: string) => {
    const link = document.createElement('a')

    link.download = name
    link.href = uri
    document.body.appendChild(link)
    link.click()
  }

  const downloadAsImage = () => {
    const node = document.getElementById('unit-label-qr-code')

    if (!node) return

    domtoimage.toJpeg(node, { quality: 1 }).then((dataUrl) => {
      downloadURI(dataUrl, `qr_code_${data?.unitId}_${moment().format('DD.MM.YY.hh.mm')}.png`.toLowerCase())
    })
  }
  const loading = isLoading || isError

  return (
    <ModalContainer
      innerClasses='!bg-transparent !border-none !shadow-none'
      containerClasses='!justify-center pb-[50px]'
      onDismiss={onDismiss}
    >
      <div className='flex flex-col items-start justify-center gap-[10px] mx-auto'>
        <div className='flex items-center justify-between w-full gap-[10px] pt-[5px]'>
          <ButtonRoundLg
            type='button'
            loading={loading}
            disabled={loading}
            className='action-brand'
            callback={() => onDismiss(null, ModalDismiss.Cancel)}
            tooltip={{ id: 'unit-label-qr-code-close', place: 'bottom', message: 'close' }}
          >
            <commonIcons.close className='!text-[1.1rem]' />
          </ButtonRoundLg>
          <ButtonRoundLg
            type='button'
            loading={loading}
            disabled={loading}
            className='action-success'
            callback={() => downloadAsImage()}
            tooltip={{ id: 'unit-label-qr-code-download', place: 'bottom', message: 'Download' }}
          >
            <commonIcons.download className='!text-[1.2rem]' />
          </ButtonRoundLg>
        </div>
        <div className='bg-white rounded-3xl border border-border px-[10px] py-[5px] overflow-hidden shadow'>
          <div id='unit-label-qr-code' className='flex h-[565px] w-[330px] sm:h-[330px] sm:w-[565px]'>
            <div className='bg-white px-[10px] py-[15px]'>
              <div className='text-text h-[555px] w-[300px] sm:h-[300px] sm:w-[555px] overflow-hidden relative flex flex-col sm:flex-row items-start sm:items-center justify-start sm:justify-between'>
                <div className='max-h-[300px] h-[300px] rotate-90 sm:rotate-0'>
                  {qrData && <QRCodeGenerator data={qrData} bgColor='#FFF' fgColor='#2D2D30' logo='assets/logos/logo_r_dark_qr_code.png' />}
                </div>
                <div>
                  <div className='mt-[90px] sm:mt-0 sm:ml-[50px] w-[300px] h-[200px] flex flex-col gap-[0px] sm:rotate-[-90deg] uppercase jost-medium text-[25px]'>
                    <div className='flex items-center justify-between'>
                      <div>IMEI:</div>
                      <div>{data?.imei}</div>
                    </div>
                    <div className='flex items-center justify-between'>
                      <div>Serial no:</div>
                      <div>{data?.serialNo}</div>
                    </div>
                    <div className='flex items-end justify-between'>
                      <div>Account:</div>
                      {data?.isActivated && <div className='grow text-right'>{data?.accountNo}</div>}
                      {!data?.isActivated && <div className='grow ml-[10%] mb-[5px] border-b-[1px] border-[black]' />}
                    </div>
                    <div className='flex items-end justify-between'>
                      <div>Date:</div>
                      <div>{moment.utc(data?.dateLoaded).local().format('DD MMM YYYY')}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalContainer>
  )
}
